import { ReactNode } from 'react';
import ApplyButton from './ApplyButton';
import OnedriveButton from './OnedriveButton';
import { FilterDialog } from './FilterDialog';
import { GroupByDialog } from './GroupByDialog';
import OpStructuresDialog from './OpStructuresDialog';
import { DiscountsDialog } from './DiscountsDialog';
import ReportActionsRow from './ReportActionsRow';

interface ReportFilterActionsProps {
  applyDisabled?: boolean;
  onedriveDisabled?: boolean;
  children?: ReactNode;
  hasCountry?: boolean;
}

const ReportFilterActions = ({
  applyDisabled,
  onedriveDisabled,
  children,
  hasCountry,
}: ReportFilterActionsProps) => (
  <ReportActionsRow data-tour="report-filter-actions">
    {children}
    <OpStructuresDialog />
    <DiscountsDialog />
    <FilterDialog />
    <GroupByDialog />
    <ApplyButton disabled={applyDisabled} />
    <OnedriveButton disabled={onedriveDisabled} hasCountry={hasCountry} />
  </ReportActionsRow>
);

export default ReportFilterActions;
